import styles from '../components/style.module.scss'
import { useRef } from 'react';
import gsap from 'gsap';
import floating1 from '../img/float1.jpg'
import floating2 from '../img/float2.jpg'
import floating3 from '../img/float3.jpg'
import floating4 from '../img/float4.jpg'
import floating5 from '../img/float5.jpg'
import floating6 from '../img/float6.jpeg'
import floating7 from '../img/float7.jpg'
import floating8 from '../img/float8.jpg'
import PageTransition from '../components/PageTransition';


// const imageCategories = [
//   { src: floating1, category: 'Action' },
//   { src: floating2, category: 'Adventure' },
//   { src: floating7, category: 'RPG' },
//   { src: floating4, category: 'Strategy' },
//   { src: floating6, category: 'Simulation' },
//   { src: floating8, category: 'Indie' },
//   { src: floating3, category: 'Horror' },
//   { src: floating5, category: 'Multiplayer' }
// ];


export default function Categories() {

  const plane1 = useRef(null);
  const plane2 = useRef(null);
  const plane3 = useRef(null);
  let requestAnimationFrameId = null;
  let xForce = 0;
  let yForce = 0;
  const easing = 0.08;
  const speed = 0.01;

  const manageMouseMove = (e) => {
    const { movementX, movementY } = e
    xForce += movementX * speed;
    yForce += movementY * speed;

    if(requestAnimationFrameId == null){
      requestAnimationFrameId = requestAnimationFrame(animate);
    }
  }

  const lerp = (start, target, amount) => start * (1 - amount) +target * amount;

  const animate = () => {
    xForce = lerp(xForce, 0, easing);
    yForce = lerp(yForce, 0, easing);
    gsap.set(plane1.current, {x: `+=${xForce}`, y: `+=${yForce}`})
    gsap.set(plane2.current, {x: `+=${xForce * 0.5}`, y: `+=${yForce * 0.5}`})
    gsap.set(plane3.current, {x: `+=${xForce * 0.25}`, y: `+=${yForce * 0.25}`})

    if(Math.abs(xForce) < 0.01) xForce = 0;
    if(Math.abs(yForce) < 0.01) yForce = 0;
    
    if(xForce != 0 || yForce != 0){
      requestAnimationFrame(animate);
    }
    else{
      cancelAnimationFrame(requestAnimationFrameId)
      requestAnimationFrameId = null;
    }
  }


  return (
    <PageTransition>
      <main onMouseMove={(e) => {manageMouseMove(e)}} className={styles.main4}>
        <div ref={plane1} className={styles.plane}>
            <img id='img1'
              src={floating1}
              alt='image'
              width={300}
            />
            <img 
              src={floating2}
              alt='image'
              width={300}
            />
            <img 
              src={floating7}
              alt='image'
              width={225}
            />
        </div>
        <div ref={plane2} className={styles.plane}>
            <img 
              src={floating4}
              alt='image'
              width={250}
            />
            <img 
              src={floating6}
              alt='image'
              width={300}
            />
            <img 
              src={floating8}
              alt='image'
              width={225}
            />
        </div>
        <div ref={plane3} className={styles.plane}>
            <img 
              src={floating3}
              alt='image'
              width={200}
            />
            <img 
              src={floating5}
              alt='image'
              width={200}
            />
        </div>
        <div className={styles.title}>
          <h1>Categories</h1>
          <p>Explore Diverse Games!</p>
        </div>
      </main>
    </PageTransition>
  )
}